/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterDataCategoryFilters {
    getFixupPrototypeFunction() { return MasterDataCategoryFilters.fixupPrototype; }

    static newInstance(model: Partial<MasterDataCategoryFilters>): MasterDataCategoryFilters {
        let obj = Object.assign(new MasterDataCategoryFilters(), model);
        MasterDataCategoryFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterDataCategoryFilters>): MasterDataCategoryFilters {
        if (!model) return null;
        return MasterDataCategoryFilters.newInstance(<MasterDataCategoryFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterDataCategoryFilters) {
        if (!obj) return;

        models.MasterDataCategoryFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterDataCategoryFilters): boolean {
        Object.setPrototypeOf(obj, MasterDataCategoryFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Filter By cloud
     */
    cloud: Array<string>;

    /**
     * Filter By service_code
     */
    service_code: Array<string>;

    /**
     * Filter By service_name
     */
    service_name: Array<string>;

    /**
     * Filter By display_name
     */
    display_name: Array<string>;

    /**
     * Filter By generalized_category
     */
    generalized_category: Array<string>;

    /**
     * Filter By service_category
     */
    service_category: Array<string>;

    /**
     * Filter By service_type
     */
    service_type: Array<string>;

    /**
     * Filter By service_sub_category
     */
    service_sub_category: Array<string>;

}
